import palette from '../palette';

export default {
  label: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: '500'
  }
};
